import { type SxProps, type Theme } from "@mui/material/styles";

import { Box } from "ui/box";
import { Status } from "ui/status";
import { getStatusType } from "components/partials/status-indicator/status-indicator.helpers";

import { useCurrentUser } from "hooks/api/use-current-user";

import { getDisplayStatus } from "utilities";
import { hasPermission } from "utilities/user";

import { Permission } from "types/auth";

type CardStatusProps = {
  status?: string | null;
  liveText?: string;
  archivedText?: string;
  draftText?: string;
  archivedDraftText?: string;
  createdText?: string;
  clientReviewText?: string;
  approvedText?: string;
  rejectedText?: string;
  systemDraftText?: string;
  sx?: SxProps<Theme>;
};

export const StatusDisplay = ({
  status,
  liveText,
  archivedText,
  draftText,
  archivedDraftText,
  createdText,
  clientReviewText,
  approvedText,
  rejectedText,
  systemDraftText,
  sx,
}: CardStatusProps) => {
  const currentUser = useCurrentUser();
  const isClientUser = hasPermission(currentUser, Permission.PERM_CLIENT_USER);

  return (
    <Box data-testid="card-status">
      <Status
        label={getDisplayStatus({
          status,
          liveText,
          archivedText,
          draftText,
          archivedDraftText,
          createdText,
          clientReviewText,
          approvedText,
          rejectedText,
          systemDraftText,
          isClientUser,
        })}
        sx={sx}
        type={getStatusType(status ?? undefined)}
      />
    </Box>
  );
};
